var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownwardOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20V4C13 3.45614 12.5439 3 12 3C11.4561 3 11 3.45614 11 4V20C11 20.5439 11.4561 21 12 21C12.5439 21 13 20.5439 13 20ZM12.7018 19.2982L5.70175 12.2982C5.52632 12.1053 5.2807 12 5 12C4.45614 12 4 12.4561 4 13C4 13.2807 4.10526 13.5263 4.29825 13.7018L11.2982 20.7018C11.4737 20.8947 11.7193 21 12 21C12.5439 21 13 20.5439 13 20C13 19.7193 12.8947 19.4737 12.7018 19.2982ZM18.2982 12.2982L11.2982 19.2982C11.1053 19.4737 11 19.7193 11 20C11 20.5439 11.4561 21 12 21C12.2807 21 12.5263 20.8947 12.7018 20.7018L19.7018 13.7018C19.8947 13.5263 20 13.2807 20 13C20 12.4561 19.5439 12 19 12C18.7193 12 18.4737 12.1053 18.2982 12.2982Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownwardOutlined);
export default __webpack_public_path__ + "static/media/arrow_downward_outlined.f02fce14.svg";
export { ForwardRef as ReactComponent };